const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'Ahoj',
    'Ref: Page content body': 'Při příjezdu a odjezdu nezapomeňte naskenovat sběrnici QR kódu',
  },
};
export default labels;
